import PropTypes from 'prop-types';
import React from 'react';
import { formatPhone } from '../utils/phone';
import BaseTextField from './BaseTextField';

const PhoneField = ({
  name,
  label,
  prompt,
  isValid,
  placeholder,
  validationText,
  showValidation,
  ...rest
}) => {
  const { value = '', save = () => {} } = rest;

  const handleInput = e => {
    // If removing character(s), do not format.
    if (e.target.value?.length < value.length) {
      return save(e.target.value);
    }
    save(formatPhone(e.target.value));
  };

  return (
    <BaseTextField
      type="tel"
      inputMode="tel"
      isValid={isValid}
      prompt={prompt}
      label={label}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={handleInput}
      validationText={validationText}
      showValidation={showValidation}
    />
  );
};

export default PhoneField;

PhoneField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  prompt: PropTypes.string,
  isValid: PropTypes.bool,
  placeholder: PropTypes.string,
  validationText: PropTypes.string,
  showValidation: PropTypes.bool
};
